// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import coffeeIcon from "@/assets/icons/aop/coffee.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type CoffeeIconProps = Omit<IconProps, "name">;

export function CoffeeIcon(props: CoffeeIconProps): React.ReactNode {
  return <Icon name={coffeeIcon} {...props} />;
}
